import microuniversoApi from "app/api/microuniversoApi";
import store from "app/redux/store/store";
import { WindowMU } from "app/types/WindowMU";

declare var window:WindowMU

export async function atualizarOrcamento() {

    const identificadorOrcamento = store.getState().orcamento.IdentificadorOrcamento

    // const orcamentoAtualizado = atualizarItens ? 
    //     await microuniversoApi.Orcamento.obterItensTotaisOrcamento(identificadorOrcamento) : 
    //     await microuniversoApi.Orcamento.obterItensTotaisOrcamento(identificadorOrcamento)

    const orcamentoAtualizado = await microuniversoApi.Orcamento.obterItensTotaisOrcamento(identificadorOrcamento)

    window.orcamentoController.model.atualizar(orcamentoAtualizado, true, true, true)


}

window.atualizarOrcamento = atualizarOrcamento